<template>
  <div class="Fuell-Table Fuell-Table--users" ref="table">
    <div class="Fuell-Table--header">
      <div
        @click="sortByField('firstName')"
        class="Fuell-Table--item Fuell-Table--sortable"
      >
        <span v-t="{path: 'NAME'}"></span>
        <span
          class="sortable-handler"
          :class="getSortableClass(isSortedByField('firstName'), sortDirection('firstName'))"
        ></span>
      </div>

      <div
        @click="sortByField('email')"
        class="Fuell-Table--item Fuell-Table--sortable"
      >
        <span v-t="{path: 'EMAIL'}"></span>
        <span
          class="sortable-handler"
          :class="getSortableClass(isSortedByField('email'), sortDirection('email'))"
        ></span>
      </div>

      <div
        @click="sortByField('rawRoles')"
        class="Fuell-Table--item Fuell-Table--sortable"
      >
        <span v-t="{path: 'ROLES'}"></span>
        <span
          class="sortable-handler"
          :class="getSortableClass(isSortedByField('rawRoles'), sortDirection('rawRoles'))"
        ></span>
      </div>

      <div
        @click="sortByField('status.statusType.code')"
        class="Fuell-Table--item Fuell-Table--sortable"
      >
        <span v-t="{path: 'MEMBERSHIP_STATUS'}"></span>
        <span
          class="sortable-handler"
          :class="getSortableClass(isSortedByField('status.statusType.code'), sortDirection('status.statusType.code'))"
        ></span>
      </div>

      <!-- <div class="Fuell-Table--item">
        <span v-t="{path: 'users_physical_card_status'}"></span>
      </div> -->
      <div class="Fuell-Table--item">
        <span v-t="{path: 'users_budgets'}"></span>
      </div>
      <div class="Fuell-Table--item">
        <span v-t="{path: 'users_identifier'}"></span>
      </div>
      <div class="Fuell-Table--item">
        <span v-t="{path: 'users_expense_center'}"></span>
      </div>

      <div class="Fuell-Table--item">
        <span v-t="{path: 'user_list_table_header_invited_on'}"></span>
      </div>

    </div>

    <div class="Fuell-Table--content">
      <office-users-user-list-table-row
        v-for="user in users"
        :key="user.id"
        :user="user"
        @showUserActionsModal="showUserActionsModal"
      ></office-users-user-list-table-row>
    </div>

    <div
      class="Fuell-Table--spinner"
      v-if="isCallingUsers"
    >
      <spinner></spinner>
    </div>
  </div>
</template>

<script>
import _usersTableHandlerMixin from '../../_mixins/_usersTableHandlerMixin'
import _usersTableSortingHandler from '../../_mixins/_usersTableSortingHandler'
import OfficeUsersUserListTableRow from './OfficeUsersUserListTableRow'
import _paginationHandlerMixin from '@/components/Commons/_mixins/_paginationHandlerMixin'
import _sortableTableMixin from '@/components/Commons/_mixins/_sortableTableMixin'
import Spinner from '@/components/Commons/Spinner'
export default {
  name: 'OfficeUsersListTable',
  mixins: [_usersTableHandlerMixin, _paginationHandlerMixin, _usersTableSortingHandler, _sortableTableMixin],
  components: { OfficeUsersUserListTableRow, Spinner },
  methods: {
    showUserActionsModal (event) {
      this.$emit('showUserActionsModal', event)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/tables/users";
</style>
